import { useState } from 'react';

export default function Testimonials() {
  const [activeSlide, setActiveSlide] = useState(0);

  const handleDotClick = (index) => {
    setActiveSlide(index);
  };

  return (
    <section id="testimonials" className="testimonials">
      <h2 className="section-title" style={{  color: 'white', fontSize: '2rem', fontFamily: 'serif', fontWeight: '400', textAlign: 'center', width: '100%', marginBottom: '-1rem' , marginTop: '2rem' }}>Wizards & Muggles Love It</h2>
      
      <div className="testimonial-container">
        <div className="testimonial-slider" style={{transform: `translateX(-${activeSlide * 33.333}%)`}}>
          <div className="testimonial-slide">
            <div className="testimonial-card">
              <p className="testimonial-quote">I&apos;ve always wanted to experience the magic in my own home. My WizardPortrait feels almost like having a friend who&apos;s always there when I need them.</p>
              <div className="testimonial-author">
               
                <div className="author-info">
                  <h4>Sarah M.</h4>
                  <p>Tech enthusiast</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="testimonial-slide">
            <div className="testimonial-card">
              <p className="testimonial-quote">As a Harry Potter fan, this is the closest thing to magic I&apos;ve experienced. The portrait is so funny and smart it makes me laugh out loud!</p>
              <div className="testimonial-author">
            
                <div className="author-info">
                  <h4>James T.</h4>
                  <p>Early adopter</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="testimonial-slide">
            <div className="testimonial-card">
              <p className="testimonial-quote">It&apos;s both a beautiful piece of decor and an incredibly useful assistant. My kids are absolutely enchanted by it.</p>
              <div className="testimonial-author">
              
                <div className="author-info">
                  <h4>Lisa K.</h4>
                  <p>Parent of three</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="testimonial-controls">
          {[0, 1, 2].map((index) => (
            <div 
              key={index}
              className={`testimonial-dot ${activeSlide === index ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            ></div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .testimonials {
          background: radial-gradient(circle at 50% 50%, rgba(59, 51, 74, 0.2) 0%, rgba(21, 4, 51, 0) 70%);
          padding: 1rem 2rem;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        
        .section-title {
          font-family: 'Cinzel Decorative', serif;
          font-size: 2.5rem;
          text-align: center;
          margin-bottom: 3rem;
          position: relative;
          display: inline-block;
          color: white;
          font-weight: 600;
        }
        
        .section-title::after {
          content: '';
          position: absolute;
          width: 80px;
          height: 4px;
            background: #A16207;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
        }
        
        .testimonial-container {
          max-width: 1200px;
          margin: 4rem auto 0;
          position: relative;
          overflow: hidden;
        }
        
        .testimonial-slider {
          display: flex;
          width: 300%;
          transition: var(--transition);
        }
        
        .testimonial-slide {
          width: 33.333%;
          padding: 0 1rem;
        }
        
        .testimonial-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border-radius: 15px;
          padding: 3rem;
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
          position: relative;
          color: white;
        }
        
        .testimonial-quote {
          font-size: 1rem;
          font-style: italic;
          margin-bottom: 2rem;
          line-height: 1.6;
          position: relative;
        }
        
        .testimonial-quote::before {
          content: '"';
          position: absolute;
          top: -30px;
          left: -10px;
          font-size: 5rem;
          color: #A16207;
          opacity: 0.3;
          font-family: 'Cinzel Decorative', serif;
        }
        
        .testimonial-author {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .author-image {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 1rem;
        }
        
        .author-image img,
        .author-image :global(img) {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .author-info h4 {
          font-size: 1.2rem;
          margin-bottom: 0.3rem;
        }
        
        .author-info p {
          font-size: 0.9rem;
          opacity: 0.7;
        }
        
        .testimonial-controls {
          display: flex;
          justify-content: center;
          margin-top: 3rem;
          gap: 1rem;
        }
        
        .testimonial-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.3);
          cursor: pointer;
          transition: 0.2s ease-in-out;
        }
        
        .testimonial-dot.active {
          background: #A16207;
          
        }

        @media (max-width: 768px) {
          .testimonial-card {
            padding: 1.5rem;
          }
        
          
        }
      `}</style>
    </section>
  );
} 